import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hostDetails: null,
  trialDetails: null,
  searchDetails: [],
};

const addTrialSlice = createSlice({
  name: "addTrial",
  initialState,
  reducers: {
    setHostDetails: (state, action) => {
      state.hostDetails = action.payload;
    },
    setTrialDetails: (state, action) => {
      state.trialDetails = action.payload;
    },
    setSearchDetails: (state, action) => {
      state.searchDetails = action.payload;
    },
  },
});

export const { setHostDetails, setTrialDetails, setSearchDetails } =
  addTrialSlice.actions;

export default addTrialSlice.reducer;
